import {Entity} from '../base/entity';
import {PartijaSpecifikacija} from '../nabavke/PartijaSpecifikacija';
import {Item} from '../lookups/item';

export class DocumentPartijaSpecifikacija extends Entity {

  public static readonly TABLENAME = 'dokument_partija_specifikacija';

  public static readonly ID = 'id';
  public static readonly DOCUMENT_ID = 'document_id';
  public static readonly PARTIJA_SPECIFIKACIJA_ID = 'partija_specifikacija_id';
  public static readonly QUANTITY = 'quantity';
  public static readonly ITEM_ID = 'item_id';
  public static readonly PRETHODNA_REALIZACIJA = 'prethodna_realizacija';

  id: number;
  documentId: string;
  partijaSpecifikacijaId: number;
  quantity: number;
  itemId: string;
  prethodnaRealizacija: number;
  deletedAt: Date;

  item: Item;
  partijaSpecifikacija: PartijaSpecifikacija;
}
